export default "__VITE_ASSET__ChrjisP$__"